import axios from 'axios';
import { axiosInstance } from './api';
import * as ActionTypes from '../store/ActionTypes';
import * as constants from '../store/Constants';
const API_URL = "/api";

export const actionCreators = {
    authentication: (response) => ({ type: ActionTypes.userAuthentication, payload: response }),
    authenticationResponse: (response) => ({ type: ActionTypes.authenticationResponse, payload: response }),
    onIsAuthentication: () => ({ type: ActionTypes.setAuthentication, payload: true }),
    onIsUnauthenticate: () => ({ type: ActionTypes.setUnauthenticate, payload: false }),
    forgotPassword: (response) => ({ type: ActionTypes.forgotPassword, payload: response }),
    userResponse: (response) => ({ type: ActionTypes.userResponse, payload: response }),
    validateSecureCode: (response) => ({ type: ActionTypes.validateSecureCode, payload: response }),
    confirmChangePassword: (response) => ({ type: ActionTypes.confirmChangePassword, payload: response }),
    getSettings: (settings) => ({ type: ActionTypes.getSettings, payload: settings }),
    getRoles:(roles) => ({type:ActionTypes.getRoles, payload:roles}),
    setUser: (user) => ({ type: ActionTypes.getUser, payload: user }),
    updateResponse: (response) => ({ type: ActionTypes.updateResponse, payload: response }),
    updateUser: (user) => ({ type: ActionTypes.updateUser, payload: user }),
    createUser: (user) => ({ type: ActionTypes.createUser, payload: user }),
    getUser: (user) => ({ type: ActionTypes.getUser, payload: user }),
    logout: () => ({ type: ActionTypes.logOut }),
    silentLogout: () => ({type: ActionTypes.silentLogOut}) 
};

export const getUsersPaginated = (filter, pageNumber, pageSize, orderBy, descending, onlyActive) => {
    const url = `user/SearchUsersPaginated?filter=${filter}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderBy=${orderBy}&descending=${descending}&onlyActive=${onlyActive}`;
    return axiosInstance().get(url);
}

export const getRoles = (callback, context) => {
    return dispatch => {
        const url = `role/GetAllowedRoles`;
        return axiosInstance().get(url).then(response => {
            dispatch(actionCreators.getRoles(response))
            callback(response, context);
        }).catch(response => callback(response.response, context) );
    }
}

export const getUser = (callback, context, id) => {
    return dispatch => {
            const url = `user/GetByUserId/${id}`;
            return axiosInstance().get(url).then(response => {
                dispatch(actionCreators.getUser(response.data.data))
                callback(response, context);
            }).catch(response => callback(response.response, context));
    }
}

export const updateUser = (user) => {
    return dispatch => {
        console.log(user);
        const url = `user/PutAsync/${user.userId}`;
        return axiosInstance().put(url, user).then(response => {
            dispatch(actionCreators.updateUser(response))
            console.log(response, "response")
            dispatch(actionCreators.updateResponse(response))
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}

export const updateResponse = (response) => {
    return dispatch => {
        dispatch(actionCreators.updateResponse(response));
    }
}

export const createUser= (user) => {
    return dispatch => {
        const url = `user/PostAsync`;
        return axiosInstance().post(url, user).then(response => {
            dispatch(actionCreators.createUser(response))
            console.log(response, "response")
            dispatch(actionCreators.updateResponse(response))
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}

export const authenticate = (userLogin) => {
    return dispatch => {
        const url = `${API_URL}/user/Authenticate`;
        return axios.post(url, userLogin).then(response => {
            dispatch(actionCreators.authentication(response))
        }).catch(response => { dispatch(actionCreators.authenticationResponse(response.response)) });
    }
}

export const authenticationResponse = (response) => {
    return dispatch => {
        dispatch(actionCreators.authenticationResponse(response));
    }
}

export const getCurrentUser = () => {
    if (sessionStorage.getItem(constants.tokenName))
        return JSON.parse(sessionStorage.getItem(constants.tokenName));
    return null;
}

export const getPermission = () => {
    let isAdmin = false;
    let isOwner = false;
    let isViewer = false;
    let isContributor = false;
    let isNone = false;
    const userInfo = getCurrentUser();
    if (userInfo != null) {
        switch (userInfo.data.roleName) {
            case constants.roleAdmin:
                isAdmin = true;
                break;
            case constants.roleOwner:
                isOwner = true;
                break;
            case constants.roleViewer:
                isViewer = true;
                break;
            case constants.roleContributor:
                isContributor = true;
                break;
            case constants.roleNone:
                isNone = true;
                break;
        }
    }
    return { isAdmin: isAdmin, isOwner: isOwner, isViewer: isViewer, isContributor: isContributor, isNone: isNone }
}
export const logoutService = () => {
    return dispatch => {
        sessionStorage.removeItem(constants.tokenName);
        dispatch(actionCreators.logout());
    }
}

export const SilentLogoutService = () => {
    return dispatch => {
        sessionStorage.removeItem(constants.tokenName);
        dispatch(actionCreators.silentLogout());
    }
}


export function checkAuthentication() {
    return async (dispatch) => {
        const auth = await window.sessionStorage.getItem(constants.tokenName);
        const formattedAuth = typeof auth === "string" ?JSON.parse(auth) :null;
        formattedAuth ? dispatch(actionCreators.onIsAuthentication()) : dispatch(actionCreators.onIsUnauthenticate());
    };
}

export const userResponseService = (response) => {
    return dispatch => {
        dispatch(actionCreators.userResponse(response));
    }
}

export const forgotPasswordService = (email) => {
    return dispatch => {
        const url = `${API_URL}/user/ForgotPassword/${email}`;
        return axios.get(url).then(response => {
            dispatch(actionCreators.forgotPassword(response))
        }).catch(response => { dispatch(actionCreators.userResponse(response.response)) });
    }
}

export const validateSecureCodeService = (code) => {
    return dispatch => {
        const url = `${API_URL}/user/ValidateSecureCode/${code}`;
        return axios.get(url).then(response => {
            dispatch(actionCreators.validateSecureCode(response))
        }).catch(response => { dispatch(actionCreators.validateSecureCode(response.response)) });
    }
};

export const getSettings = (callback, context) => {
    return dispatch => {
            const url = `/api/AppSettings`;
            return axios.get(url).then(response => {
                dispatch(actionCreators.getSettings(response.data))
                callback(response, context);
            }).catch(response => callback(response.response, context));
    }
}

export const getAppSettingsEnvironment = async ({ callback = () => {} }) => {
    const url = '/AppSettings'
    try {
      const value = await axiosInstance().get(url)
      callback(value.data.value.environment)
      return null
    } catch (error) {
      callback('')
      return error
    }
}

export const confirmChangePasswordService = (userChangePassword) => {
    return dispatch => {
        const url = `${API_URL}/user/PutConfirmChangePasswordAsync`;
        return axios.put(url, userChangePassword).then(response => {
            dispatch(actionCreators.confirmChangePassword(response))
        }).catch(response => { dispatch(actionCreators.userResponse(response.response)) });
    }
};